// Meta's business-scoped user ID: "<country code>.[ENT.]<up to 128 alphanumerics>", e.g. "TR.1637381144549459"
const BSUID_PATTERN = /^[A-Z]{2}\.(ENT\.)?[A-Za-z0-9]{1,128}$/;

export const isBusinessScopedUserId = (id) => BSUID_PATTERN.test(String(id ?? ''));
